import "./App.css";
import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./component/header";
import Footer from "./component/Footer";
import Home from "./pages/Home";
import About from "./pages/AboutUs";
import Contact from "./pages/Contactus";
import Privacy from "./pages/PrivacyPolicy";
import Termscondition from "./pages/TermsCondition";
import Return from "./pages/Return";
import Hoodies from "./pages/Hoodies";
import Hats from "./pages/HatsPolosMore";
import Services from "./pages/Services";
import Mugs from "./pages/Mugs";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Productdec from "./pages/AddProduct";
import TshirtDesignerApp from "./tshirt-designer/App";
import ProtectedRoute from "./component/protectedRoute";
import CustomAlert from "./component/alerts/customAlert";
import Help from './pages/HelpCenter'

import CategoryProduct from "pages/categoryProduct";

function App() {
  const [showAlert, setShowAlert] = useState(false);

  const handleUnauthorized = () => {
    setShowAlert(true);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <div className="App">
      {/* Alert message for unauthorized users */}
      <CustomAlert
        message="Login first to Create your own shirt"
        onClose={handleCloseAlert}
        isOpen={showAlert}
      />

      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/Termscondition" element={<Termscondition />} />
        <Route path="/Return-Policy" element={<Return />} />
        <Route path="/sweathoodies" element={<Hoodies />} />
        <Route path="/services" element={<Services />} />
        <Route path="/sweat-hoodies" element={<Hoodies />} />
        <Route path="/HatsPolos" element={<Hats />} />
        <Route path="/mugs" element={<Mugs />} />
        <Route path="/productDetail/:slug" element={<Productdec />} />
        <Route path="/Cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/categories/:slug" element={<CategoryProduct />} />
         <Route path="/helpcenter" element={<Help />} />


        {/* Protected Designer Route */}
        
         <Route path="/designer" element={<TshirtDesignerApp />} />
        
        {/* <Route
          path="/designer"
          element={
            <ProtectedRoute onUnauthorized={handleUnauthorized}>
              <TshirtDesignerApp />
            </ProtectedRoute>
          } */}
    
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
